module.exports = __webpack_public_path__ + "img/rectangle-barcode.9f9497bd.svg";